export default function CTA() {
  return (
    <section className="py-20 px-6 bg-gradient-to-br from-primary-600 to-primary-700">
      <div className="container mx-auto max-w-4xl text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Transform Your Kitchen?
        </h2>
        <p className="text-xl text-primary-100 mb-10 max-w-2xl mx-auto">
          Join thousands of home cooks who have simplified their meal planning with WithSous. Start
          your culinary journey today.
        </p>
        <a
          href="https://withsous.app"
          className="inline-block px-10 py-4 bg-white text-primary-600 text-lg font-semibold rounded-lg hover:bg-neutral-50 transition shadow-lg hover:shadow-xl"
        >
          Get Started for Free
        </a>
        <p className="text-primary-100 mt-6 text-sm">No credit card required • Free forever plan</p>
      </div>
    </section>
  );
}
